export default {
  save: "Save",
  "N/A": "N/A",
};
